// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__380XR","label":"LabeledBox_label__UlJB9"};